import { Link } from 'react-router-dom'
import type { Arrival } from '@/api/endpoints'

const DEFAULT_ARRIVAL_IMAGE = '/images/boxes.jpg'

type ArrivalCardProps = Arrival

const ArrivalCard = ({
  date,
  dateLabel,
  image = DEFAULT_ARRIVAL_IMAGE,
  productsCount,
  moyskladApplicable,
  slug,
  url,
}: ArrivalCardProps) => {
  const href = url ?? (slug ? `/arrivals/${slug}` : '/arrivals')

  return (
    <article>
      <Link
        to={href}
        className="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      >
        <div className="relative aspect-4/3">
          <img
            src={image}
            alt={`Поступление от ${date}`}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover transition-transform duration-200 group-hover:scale-[1.02]"
          />
        </div>
        <div className="p-4">
          <p className="font-semibold text-gray-900 group-hover:text-primary">
            Поступление от {date}
          </p>
          {dateLabel && (
            <p className="text-sm text-gray-500 mt-0.5">{dateLabel}</p>
          )}
          {typeof moyskladApplicable === 'boolean' && (
            <p className={`mt-1 text-xs font-semibold ${moyskladApplicable ? 'text-green-600' : 'text-amber-600'}`}>
              {moyskladApplicable ? 'Проведено' : 'Ожидается'}
            </p>
          )}
          {typeof productsCount === 'number' && productsCount > 0 && (
            <p className="text-xs text-gray-400 mt-1">{productsCount} товаров</p>
          )}
        </div>
      </Link>
    </article>
  )
}

export default ArrivalCard
